import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css'
import '@fortawesome/fontawesome-pro/css/all.css'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#7cb54a',
    secondary: '#D19608',
    tertiary: '#0AD19F'
  }
})
